import React from 'react';
import styled from 'styled-components';
import { useIntl } from 'react-intl';
import { Label, Text } from '../../components/CommonStyledComponents/CommonStyledComponents';
import ToolTip from '../../components/NewTooltip/NewTooltip';
import { CustomField } from '../../models/aircraft';
import { CUSTOM_FIELD_VIEWS } from './CustomFieldsEditMainDetails';

interface CustomFieldsViewMainDetailsProps {
  foundCustomField: CustomField;
}

const Wrapper = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  grid-gap: 20px;
  margin-top: 20px;
  @media (max-width: 450px) {
    grid-template-columns: 1fr;
  }
`;

const CustomFieldsViewMainDetails: React.FC<CustomFieldsViewMainDetailsProps> = ({ foundCustomField }) => {
  const { formatMessage } = useIntl();

  return (
    <Wrapper data-testid="CustomFieldViewMainDetails--Wrapper">
      <div data-testid="CustomFieldViewMainDetails--Title">
        <Label>
          {formatMessage({ id: 'text.title' })}
          <ToolTip text={formatMessage({ id: 'text.displayOnTheLeftSideOfIpad' })} />
        </Label>
        <Text>{foundCustomField?.title}</Text>
      </div>
      <div data-testid="CustomFieldViewMainDetails--Required">
        <Label>{formatMessage({ id: 'text.required' })}</Label>
        <Text>{foundCustomField?.required ? 'Yes' : 'No'}</Text>
      </div>
      <div data-testid="CustomFieldViewMainDetails--View">
        <Label>
          {formatMessage({ id: 'text.location' })}
          <ToolTip text={formatMessage({ id: 'text.fieldDataDisplayedOn' })} />
        </Label>
        <Text>{CUSTOM_FIELD_VIEWS.find((view) => view.value === foundCustomField?.view)?.title}</Text>
      </div>
      <div data-testid="CustomFieldViewMainDetails--Type">
        <Label>
          {formatMessage({ id: 'text.type' })}
          <ToolTip text={formatMessage({ id: 'text.dataTypeEnteredIntoField' })} />
        </Label>
        <Text>{foundCustomField?.type}</Text>
      </div>
      <div data-testid="CustomFieldViewMainDetails--Heading">
        <Label>
          {formatMessage({ id: 'text.heading' })}
          <ToolTip text={formatMessage({ id: 'text.displayedAboveFieldOnIpad' })} />
        </Label>
        <Text>{foundCustomField?.heading}</Text>
      </div>
    </Wrapper>
  );
};

export default CustomFieldsViewMainDetails;
